var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.028,
    height: 18.655,
    viewBox: "0 0 15.028 18.655",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "repeat_1_",
    "data-name": "repeat (1)",
    transform: "translate(-2.25 0.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25294",
    "data-name": "Path 25294",
    d: "M17,1l3.006,3.006L17,7.012",
    transform: "translate(-3.478)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25295",
    "data-name": "Path 25295",
    d: "M3,9.509v-1.5A3.006,3.006,0,0,1,6.006,5H16.528",
    transform: "translate(0 -0.994)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25296",
    "data-name": "Path 25296",
    d: "M6.006,21.012,3,18.006,6.006,15",
    transform: "translate(0 -3.478)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25297",
    "data-name": "Path 25297",
    d: "M16.528,13v1.5a3.006,3.006,0,0,1-3.006,3.006H3",
    transform: "translate(0 -2.981)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.b794217c899fa72bccd299990cb57b2a.svg";
export { ForwardRef as ReactComponent };